import { Steps } from "antd"

/**
 * 
 * @param {*} props 
 * @param {Number} props.current To set the current step, counting from 0.
 * @param {Array[Object]} props.items StepItem content Ref. https://ant.design/components/steps#stepitem
 * @example props.items => [
      {
        title: 'Finished',
        description: 'Some description',
        icon: <ReactNode>
      },
      {
        title: 'In Progress',
        description: 'Some description',
        subTitle: 'Left 00:00:08',
        icon: <ReactNode>
      },
      ...
    ]
 * @param {String} props.labelPlacement To place title and description with horizontal or vertical direction
 */

const StepsNav = (props) => {
    return <Steps
        className={props.className}
        current={props.current}
        items={props.items}
        status={props.status}
        labelPlacement={props.labelPlacement || "vertical"}
        percent={props.percent}
    />
}

export default StepsNav